import { callApiNew, callApiNewTest } from 'api/axios'
import { formatArticle, formatCategory } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import {
  ArticleType as ArticleConstType,
  FEATURE_FLAG,
  assetImagePath,
} from 'interfaces/constants'
import { Article, ArticleApi, CategoryApi } from 'interfaces/types'
import { cleanLink } from 'utils/htmlHelper'
import { MeasureOptions } from 'utils/measureTaskExecTime'

export async function fetchArticleRelatedCategories(
  article: Article,
  measureOptions?: MeasureOptions,
) {
  const currentCategory = getArticleCurrentCategory(article)
  if (!currentCategory) return []
  const slug =
    currentCategory.slug ||
    cleanLink(currentCategory.permalink).split('/').pop()

  const res = await callApiNewTest(
    PATHS.CATEGORY.GET_CATEGORY_DETAIL,
    {
      params: {
        slug: slug || '',
      },
    },
    undefined,
    undefined,
    undefined,
    measureOptions,
  )

  const subCategories: Array<CategoryApi> = Array.isArray(
    res?.data?.sub_categories,
  )
    ? res?.data?.sub_categories
    : []
  return subCategories.slice(0, 3).map(formatCategory)
}
export function getArticleCurrentCategory(article: Article) {
  return Object.keys(article.category).length > 0
    ? article.category
    : article.categories?.sort(
        (a, b) => b.permalink.length - a.permalink.length,
      )[0]
}

/**
 *
 * @param requestFrom for logging purpose. Please use user token for this
 * @returns
 */
export async function getArticleBySlug({
  slug,
  skipIds = '',
  isRelated = '',
  requestFrom,
}: {
  slug?: string
  skipIds?: string
  isRelated?: string | number
  requestFrom?: string | undefined
}): Promise<Article | null> {
  if (!slug) return null
  const newApiRes = await callApiNew(PATHS.ARTICLE.GET_ARTICLE_DETAIL, {
    params: {
      slug: slug.split('/').filter(Boolean).join('/'),
      skipIds,
      isRelated,
    },
  })
  const redirectUrl: string = newApiRes?.data?.redirect_url
  if (redirectUrl) {
    return getArticleBySlug({
      slug: redirectUrl,
      skipIds,
      isRelated,
      requestFrom,
    })
  }
  const newApiData: ArticleApi = newApiRes?.data?.post
  if (!newApiData) return null
  const newRelatedData: Array<ArticleApi> =
    newApiRes?.data?.related_articles || []
  const newArticleData = formatArticle(newApiData)
  newArticleData.relatedArticles = newRelatedData.map(formatArticle)
  if (FEATURE_FLAG.articleType === ArticleConstType.ArticleType3) {
    newArticleData.relatedCategories = []
  } else {
    newArticleData.relatedCategories = await fetchArticleRelatedCategories(
      newArticleData,
    )
  }
  return newArticleData
}

export const getArticleCardDisplayAuthor = (
  article: Article,
): {
  name: string
  avatar: string
  permalink: string
  type: 'expert' | 'author' | 'reviewer'
} => {
  if (article.expert?.name) {
    return {
      name: article.expert.name,
      avatar: article.expert.thumbnailAvatar || `${assetImagePath}/avatar.jpg`,
      permalink: article.expert.permalink || '',
      type: 'expert',
    }
  }
  if (article.reviewer?.displayName) {
    return {
      name: article.reviewer.displayName,
      avatar:
        article.reviewer.thumbnailAvatar || `${assetImagePath}/avatar.jpg`,
      permalink: article.reviewer.profileUrl || '',
      type: 'reviewer',
    }
  }
  if (article.author?.displayName) {
    return {
      name: article.author.displayName,
      avatar: article.author.thumbnailAvatar || `${assetImagePath}/avatar.jpg`,
      permalink: article.author.profileUrl || '',
      type: 'author',
    }
  }
  return {
    name: '',
    avatar: `${assetImagePath}/avatar.jpg`,
    permalink: '',
    type: 'author',
  }
}

export const isPreviewSlug = () => {
  return (
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/preview')
  )
}
